import React, { useContext } from "react";
import styled, { keyframes } from "styled-components";
import DrippingAnimation from "./DrippingAnimation";
import StateContext from "../context/StateContext";

function shake(xWidth, yWidth) {
  return keyframes`
	from {
		transform: translateX(-${xWidth}, -${yWidth})
	}

	to {
		transform: translate(${xWidth}, ${yWidth})
	}
	`;
}

const Shake = styled.span.attrs((props) => ({
  xWidth: props.xWidth || 0.05,
  yWidth: props.yWidth || 0.05,
  time: props.time || "0.01s",
}))`
  animation: ${(props) => shake(props.xWidth + "em", props.yWidth + "em")}
    ${(props) => props.time} linear infinite;
  display: inline-block;
  white-space: pre;
`;

const jiggle = keyframes`
from {
	transform: rotate(1deg);
}
to {
	transform: rotate(-1deg);
}
`;

const Jiggle = styled.span`
  animation: ${jiggle} 0.1s linear infinite;
  display: inline-block;
`;

export function ShakyText(props) {
  return <Shake>{props.text}</Shake>;
}

export function JigglyText(props) {
  return <Jiggle>{props.text}</Jiggle>;
}

const PreserveWhitespaceSpan = styled.span`
  display: inline-block;
  white-space: pre;
`;

export function ParagraphWithRandomlyShakyWords(props) {
  const [state] = useContext(StateContext);
  const words = props.text.split(" ");
  return (
    <p>
      <DrippingAnimation duration={50}>
        {words.map((word, index) => {
          return Math.random() < props.probability ? (
            <React.Fragment key={index}>
              <Shake
                key={index}
                xWidth={0.05}
                yWidth={0.05}
                time={Math.random() / 4 + "s"}
                amount={state.watchedVideos}
              >
                {word + " "}
              </Shake>
            </React.Fragment>
          ) : (
            <PreserveWhitespaceSpan key={index}>
              {word + " "}
            </PreserveWhitespaceSpan>
          );
        })}
      </DrippingAnimation>
    </p>
  );
}

// TODO(gsch): Make props.text slowly transform dripping.
export function SlowlyDrippingWord(props) {
  return (
    <>
      <div></div>
    </>
  );
}

export default ShakyText;
